
import { defineComponent, onMounted, ref ,watch} from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Field } from "vee-validate";
import ShowFile from "@/components/ShowFile.vue";
import { useRouter, useRoute } from "vue-router";
import { ElNotification } from "element-plus/es";

import Item1 from "@/layout/header/partials/activity-timeline/Item1.vue";
// import UploadFile from "@/components/uploadFiles/UploadFile.vue";
import UploadData from "@/components/uploadFiles/UploadFile.vue";

import Emoji from "@/components/Emoji.vue";

export default defineComponent({
  name: "kt-otp-management-table",
  components: { UploadData, Emoji,Field , ShowFile,},
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const create_msg = ref(false);
    const router = useRouter();
    const route = useRoute();

    // const dataForm = ref({});

    const dataForm = ref({
      name: "",
      enable_direct: false,
      enable_comment: false,
      only_for_specific_posts: false,
      specific_posts: [],
      send_reply_in_comment: false,
      comments_replies: [''],
     
      messages: [
        {
          name: "", 
          type: "text", 
          text: "",
          file: undefined,
          fileUrl: undefined,
          with_file: false,
        },
      ],
      conditions: [
        {
          type: "",
          value: "",
        },
      ],
    }) as any;

    const posts = ref([])


    watch(
          () => dataForm.value.only_for_specific_posts,
          (newValue) => {
            if (newValue) {
              getPosts('');
            }
          }
        );

    const postLoading = ref(false)
    const instaData = ref()
    const getPosts = (nextPage) => {
      postLoading.value = true
      loading.value = true;
        ApiService.query(`/${route.params.platform}/${route.params.bot_id}/posts`,{params:{after : nextPage}})
          .then(({ data }) => {
           console.log(data);
           posts.value = posts.value.concat(data.data.ig_posts) 
            instaData.value = data.data
           console.log(posts.value);
            postLoading.value = false
           
          })
          .catch((e) => {
            loading.value = false;
            ElNotification({
            title: "خطا",
            message: e.response.data.validation_message,
            type: "error",
          });
          });
    };

    const save = () => {
      console.log(dataForm.value);

      // dataForm.value.comments_replies = []
      // dataForm.value.comments_replies.map((item, index) => {
      //   return  dataForm.value.comments_replies.push(item.value)
      // });

      dataForm.value.comments_replies = dataForm.value.comments_replies.filter(item => item);


      if (dataForm.value.name === '') {
        ElNotification({
            title: "خطا",
            message: "نام پاسخگو را وارد کنید",
            type: "error",
          });
      }

     else if (dataForm.value.conditions[0].value === '') {
        ElNotification({
            title: "خطا",
            message: 'شرط های پاسخگو را مشخص کنید.',
            type: "error",
          });
      }

     else if (dataForm.value.enable_comment === false && dataForm.value.enable_direct === false) {
        ElNotification({
            title: "خطا",
            message: 'حداقل یکی از موارد دایرکت یا کامنت را انتخاب کنید.',
            type: "error",
          });
      }
     else if (dataForm.value.messages.length === 1 && dataForm.value.messages[0].text==='' && dataForm.value.messages[0].type==='text') {
        ElNotification({
            title: "خطا",
            message: 'پیام را وارد کنید.',
            type: "error",
          });
      }
      else{
           loading.value = true;
        ApiService.post(`/social-media-secretary/${route.params.platform}/${route.params.bot_id}/create`, dataForm.value)
          .then(({ data }) => {
           console.log(data);
           router.push(`/automationList/${route.params.bot_id}/${route.params.platform}`)
          })
          .catch((e) => {
            loading.value = false;
            ElNotification({
            title: "خطا",
            message: e.response.data.validation_message,
            type: "error",
          });
          })
          .finally(() =>{
            dataForm.value.comments_replies = ['']
          })
      }

    };

    const addNewItems = () => {
      dataForm.value.messages.push({
        type: "text",
        text: "",
        file: undefined,
        with_file: false,
      });
    };

    const removeItem = (index) => {
      dataForm.value.messages.splice(index, 1);
    };

    const addNewCondition = () => {
      dataForm.value.conditions.push({
        type: "",
        value: "",
      });
    };

    const removeCondition = (index) => {
      dataForm.value.conditions.splice(index, 1);
    };

    const addNewReplies = () => {
      dataForm.value.comments_replies.push('');
    };

    const removeReplies = (index) => {
      dataForm.value.comments_replies.splice(index, 1);
    };

    const emojiHelper = ref({
      activeIndex: 0 as number,
      activeIndent: 0 as number,
    });

    const addEmoji = (emoji) => {
      dataForm.value.messages[emojiHelper.value.activeIndex].text += emoji;
    };

    const fileUploadedCallBack = (file, activeIndex) => {
      dataForm.value.messages[activeIndex].file = file.path;
      dataForm.value.messages[activeIndex].fileUrl = file.url;
      dataForm.value.messages[activeIndex].type =
        file.file_type === "message" ? "text" : file.file_type;
         if (file.origin_file_name)
        dataForm.value.messages[activeIndex].origin_file_name =
          file.origin_file_name;
    };

    onMounted(() => {
      // getItems();
      setCurrentPageBreadcrumbs(translate("ایجاد دستور"), []);
    });

    return {
      loading,
      getPosts,
      posts,
      translate,
      statusColor,
      dataForm,
      create_msg,
      addNewItems,
      removeItem,
      addEmoji,
      emojiHelper,
      fileUploadedCallBack,
      save,
      removeCondition,
      addNewCondition,
      removeReplies,
      addNewReplies,
      postLoading,
      instaData,
    };
  },
});
